import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";

import Footer2 from "../components/Footer2";
import { Card, Carousel } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BASE_URL } from "../config/BaseUrls";

import leftArrow from "./image/moveimgarrow.png"; // Left arrow
import rightArrow from "./image/moveimgarrow.png";
import { useAuth } from "../context/auth";
import axios from "../AxiosInstance";
import { LanguageContext } from "../context/LanguageContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Instagram, Star, X } from "lucide-react";
import { FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ChatProvider, { ChatState } from "../context/ChatProvider";
import toast from "react-hot-toast";
import SocketContext from "../context/SocketContext";
import { resolveBookImageUrl } from "../utils/urlHelpers";

// ---- Mock data -------------------------------------------------------------




// ---- UI pieces -------------------------------------------------------------
const Socials = ({ user }) => {
  const normalizeLink = (url) => {
    if (!url) return null;
    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };

  const links = {
    facebook: normalizeLink(user?.fbLinks?.[0]),
    instagram: normalizeLink(user?.instaLinks?.[0]),
    linkedin: normalizeLink(user?.linkdlnLinks?.[0]),
    twitter: normalizeLink(user?.xLinks?.[0]),
    tiktok: normalizeLink(user?.tiktokLinks?.[0]),
  };

  const items = [
    { Icon: Facebook, href: links.facebook },
    { Icon: FaXTwitter, href: links.twitter },
    { Icon: Linkedin, href: links.linkedin },
    { Icon: Instagram, href: links.instagram },
    { Icon: FaTiktok, href: links.tiktok }, // Uncomment if TikTok icon is available
  ].filter((x) => !!x.href);

  if (items.length === 0) return null;

  return (
    <div className="mt-2 flex gap-3 justify-center sm:justify-start">
      {items.map(({ Icon, href }, i) => (
        <a
          key={i}
          href={href}
          className="text-[#34c3c9] hover:opacity-80"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
};


const Stars = ({ value = 0 }) => (
  <div className="flex items-center gap-0.5 justify-center sm:justify-start">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        size={14}
        className={
          i < value ? "fill-amber-400 text-amber-400" : "text-gray-300"
        }
      />
    ))}
  </div>
);

const BookCard = ({ item, rating, showBelow, onClick, read }) => {
  const [selectedBook, setSelectedBook] = useState(null);
  const navigate = useNavigate();
  const handleBookClick = (book) => {
    if (!book) return;
    console.log("Book clicked:", book);
    const selectedBookObj = {
      bookId: undefined, // 👈 Use book.id if available
      bookCoverImage: book.coverImage, // <== This is correct
      title: book.title,
      author: book.author,
      descriptions: book.aboutBook, // ✅ add this
      titless: book.title,
      publisher: book.publisher,
      book: book.bookId, // 👈 Use book.bookId._id if available
      EAN: book.EAN, // 👈 Add EAN if available
    };
    setSelectedBook(book);
    localStorage.setItem(
      "selectedBookforreviews",
      JSON.stringify(selectedBookObj)
    );
    localStorage.setItem(
      "selectedBookforreviewsnew",
      JSON.stringify(selectedBookObj)
    );

    const isSearchBook = !!(book?.isSearchBook || book?.review?.SearchBookId);
    const bookId =
      book?.SearchBookId ||
      book?.bookId?._id ||
      book?.bookId ||
      (read ? book?.bookId : book?.bookId?._id);
    const queryParam =
      !isSearchBook && book?.EAN
        ? `ean=${encodeURIComponent(book.EAN)}`
        : `bookid=${encodeURIComponent(bookId || "")}`;

    const sourceParam = book?.review?.offilioBookId
      ? "offilio=true"
      : "searchbook=true";

    navigate(`/reviews?${queryParam}&${sourceParam}`);
  };
  return <div className="group" onClick={() => handleBookClick(item)}>
    <div className="cursor-pointer relative aspect-[2/3] w-[80%]  overflow-hidden rounded-md ring-1 ring-slate-200 shadow-sm transition-transform group-hover:-translate-y-0.5 group-hover:shadow-md">
      <img
        src={
          resolveBookImageUrl(item?.coverImage)
        }
        alt="Book cover"
        className="h-full w-full object-cover scale-70"
      />
    </div>
    {showBelow && typeof rating === "number" && (
      <div className="mt-2 flex justify-center w-[80%] ">
        <Stars value={rating} />
      </div>
    )}
  </div>
};

const Shelf = ({ title, data, withRatings = false, read = false }) => (
  <section className="mt-8">
    <h2 className="mb-3 text-lg font-semibold">{title}</h2>
    <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6">
      {data.map((b) => (
        <BookCard
          key={b.id}
          item={b}
          rating={withRatings ? b.rating : undefined}
          showBelow={withRatings}
          read={read}
        />
      ))}
    </div>
  </section>
);

const ProfileHeader = ({ image, name, gender, age, city, user, handleAmbassador }) => {
  const { lg } = useContext(LanguageContext);
  
  return <div className="flex flex-col items-center gap-6 rounded-2xl bg-[#34c3c9]/10 p-6 shadow-sm sm:flex-row">
    <div className="flex flex-col items-center sm:items-start">
      <img
        src={image}
        alt="User avatar"
        style={{ objectFit: "contain" }}
        className="h-24 w-24 rounded-full ring-4 ring-white shadow-md"
      />
      {user?.isAmbassador &&
        <button className="mt-3 rounded-full bg-[#34c3c9] px-4 py-1.5 text-sm font-medium text-white shadow hover:bg-[#2eaab0] transition-colors"
          onClick={handleAmbassador}
        >
          {lg?.chatWithAmbassador || "Chat with Ambassador"}
        </button>}
    </div>

    <div className="text-center sm:text-left">
      <h1 className="text-2xl text-left font-bold text-slate-800">{name}</h1>
      <div className="mt-1 flex items-center justify-center gap-4 text-slate-600 sm:justify-start">
        {gender && <span>♀ {gender}</span>}
        {age && <span>{age} years old</span>}
        {city && <span>📍 {city ? city : ""}</span>}
      </div>
      <Socials user={user} />
    </div>
  </div>
}
const books = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Crime",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book2.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book3.png"),
  },

  {
    image: require("../pages/image/book1.png"),
  },
  {
    image: require("../pages/image/book2.png"),
  },
  {
    image: require("../pages/image/book3.png"),
  },
  {
    image: require("../pages/image/book2.png"),
  },
  {
    image: require("../pages/image/book3.png"),
  },

  // Add more book data here as needed
];

const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <img
      src={leftArrow}
      alt="Previous"
      className={className}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        left: "-30px", // Adjust position
        top: "42%",
        transform: "translateY(-50%) rotate(180deg)", // Rotate left arrow
        width: "15px",
        height: "15px",
        cursor: "pointer",
        zIndex: 1, // Ensure it's above other elements
      }}
      onClick={(e) => {
        e.stopPropagation(); // Prevent default event bubbling
        onClick(); // Move slider to left correctly
      }}
    />
  );
};

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <img
      src={rightArrow}
      alt="Next"
      className={className}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        right: "-20px", // Adjust position
        top: "42%",
        transform: "translateY(-50%) rotate(0deg)",
        width: "15px",
        height: "15px",
        cursor: "pointer",
        zIndex: 1,
      }}
      onClick={(e) => {
        e.stopPropagation(); // Prevent default event bubbling
        onClick(); // Move slider to right correctly
      }}
    />
  );
};
const settingsd = {
  // dots: true, // Show dots for navigation
  infinite: true, // Infinite looping
  speed: 500, // Transition speed
  slidesToShow: 8, // Show 3 books at a time
  slidesToScroll: 1, // Move 1 book at a time
  draggable: true, // Allow drag functionality
  swipe: true, // Allow touch swipe
  arrows: true, // Hide default navigation arrows
  prevArrow: <CustomNextArrow />, // Custom left arrow
  nextArrow: <CustomPrevArrow />, // Custom right arrow
  rtl: false, // Make sure right-to-left mode is off
  responsive: [
    {
      breakpoint: 1300, // For screen widths <= 768px
      settings: {
        slidesToShow: 6.1, // Show 2 books at a time
      },
    },
    {
      breakpoint: 1000, // For screen widths <= 768px
      settings: {
        slidesToShow: 4.7, // Show 2 books at a time
      },
    },
    {
      breakpoint: 840, // For screen widths <= 768px
      settings: {
        slidesToShow: 4.1, // Show 2 books at a time
      },
    },
    {
      breakpoint: 768, // For screen widths <= 768px
      settings: {
        slidesToShow: 3.9, // Show 2 books at a time
      },
    },
    {
      breakpoint: 640, // For screen widths <= 768px
      settings: {
        slidesToShow: 3.2, // Show 2 books at a time
      },
    },
    {
      breakpoint: 450, // For screen widths <= 450px
      settings: {
        slidesToShow: 2.2, // Show 2.5 books at a time
        centerMode: true, // Center the active slide
        centerPadding: "20px", // Padding around the center item
      },
    },
    {
      breakpoint: 390, // For screen widths <= 450px
      settings: {
        slidesToShow: 2, // Show 2.5 books at a time
      },
    },
  ],
};
const useQuery = () => new URLSearchParams(useLocation().search);

const AmbassUserProfile = () => {
  const { lg } = useContext(LanguageContext);
  const { showLoginM, setShowLoginM } = ChatState();
  const socket = useContext(SocketContext);

  const [selectedImageLaed, setSelectedImageLaed] = useState(null);
  const fileInputRefLaed = useRef(null);

  // Load the selected image from localStorage on component mount
  useEffect(() => {
    const storedImageLaed = localStorage.getItem("ambsuserProfileImage");
    if (storedImageLaed) {
      setSelectedImageLaed(storedImageLaed);
    }
  }, []);

  const handleButtonClickLaed = () => {
    if (fileInputRefLaed.current) {
      fileInputRefLaed.current.click();
    }
  };
  const calculateAge = (dob) => {
    if (!dob) return null;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const handleFileChangeLaed = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImageLaed(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("ambsuserProfileImage", reader.result); // Save to localStorage
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  const settings = {
    // dots: true, // Show dots for navigation
    infinite: true, // Infinite looping
    speed: 500, // Transition speed
    slidesToShow: 3, // Show 3 books at a time
    slidesToScroll: 1, // Move 1 book at a time
    draggable: true, // Allow drag functionality
    swipe: true, // Allow touch swipe
    arrows: false, // Hide default navigation arrows
    responsive: [
      {
        breakpoint: 768, // For screen widths <= 768px
        settings: {
          slidesToShow: 3, // Show 2 books at a time
        },
      },
      {
        breakpoint: 450, // For screen widths <= 450px
        settings: {
          slidesToShow: 3, // Show 2.5 books at a time
          centerMode: true, // Center the active slide
          centerPadding: "0px", // Padding around the center item
        },
      },
      {
        breakpoint: 400, // For screen widths <= 450px
        settings: {
          slidesToShow: 2.1, // Show 2.5 books at a time
          centerMode: true, // Center the active slide
          centerPadding: "25px", // Padding around the center item
        },
      },
    ],
  };
  // FAtch User Details
  const [auth, setAuth] = useAuth();

  const userId = auth?.user?._id;

  const [user, setUser] = useState(null);
  const query = useQuery();
  const id = query.get("id");
  const navigate = useNavigate()
  useEffect(() => {
    if (!userId) {
      setShowLoginM(true)
      navigate("/")
    }
  }, [userId])
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`/api/v1/auth/user-profile/${id}`);
        console.log("User data:", res.data.data);

        setUser(res.data.data);
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };
    console.log("idid", id);

    if (id) {
      fetchUser();
    }
  }, [id]);
  const capitalizeWords = (str) => {
    return str
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const countryNameToCode = {
    Afghanistan: "AF",
    Albania: "AL",
    Algeria: "DZ",
    Andorra: "AD",
    Angola: "AO",
    "Antigua and Barbuda": "AG",
    Argentina: "AR",
    Armenia: "AM",
    Australia: "AU",
    Austria: "AT",
    Azerbaijan: "AZ",
    Bahamas: "BS",
    Bahrain: "BH",
    Bangladesh: "BD",
    Barbados: "BB",
    Belarus: "BY",
    Belgium: "BE",
    Belize: "BZ",
    Benin: "BJ",
    Bhutan: "BT",
    Bolivia: "BO",
    "Bosnia and Herzegovina": "BA",
    Botswana: "BW",
    Brazil: "BR",
    Brunei: "BN",
    Bulgaria: "BG",
    "Burkina Faso": "BF",
    Burundi: "BI",
    Cambodia: "KH",
    Cameroon: "CM",
    Canada: "CA",
    "Cape Verde": "CV",
    "Central African Republic": "CF",
    Chad: "TD",
    Chile: "CL",
    China: "CN",
    Colombia: "CO",
    Comoros: "KM",
    "Congo (Brazzaville)": "CG",
    "Congo (Kinshasa)": "CD",
    "Costa Rica": "CR",
    Croatia: "HR",
    Cuba: "CU",
    Cyprus: "CY",
    "Czech Republic": "CZ",
    Denmark: "DK",
    Djibouti: "DJ",
    Dominica: "DM",
    "Dominican Republic": "DO",
    Ecuador: "EC",
    Egypt: "EG",
    "El Salvador": "SV",
    "Equatorial Guinea": "GQ",
    Eritrea: "ER",
    Estonia: "EE",
    Eswatini: "SZ",
    Ethiopia: "ET",
    Fiji: "FJ",
    Finland: "FI",
    France: "FR",
    Gabon: "GA",
    Gambia: "GM",
    Georgia: "GE",
    Germany: "DE",
    Ghana: "GH",
    Greece: "GR",
    Grenada: "GD",
    Guatemala: "GT",
    Guinea: "GN",
    "Guinea-Bissau": "GW",
    Guyana: "GY",
    Haiti: "HT",
    Honduras: "HN",
    Hungary: "HU",
    Iceland: "IS",
    India: "IN",
    Indonesia: "ID",
    Iran: "IR",
    Iraq: "IQ",
    Ireland: "IE",
    Israel: "IL",
    Italy: "IT",
    Jamaica: "JM",
    Japan: "JP",
    Jordan: "JO",
    Kazakhstan: "KZ",
    Kenya: "KE",
    Kiribati: "KI",
    "Korea, North": "KP",
    "Korea, South": "KR",
    Kuwait: "KW",
    Kyrgyzstan: "KG",
    Laos: "LA",
    Latvia: "LV",
    Lebanon: "LB",
    Lesotho: "LS",
    Liberia: "LR",
    Libya: "LY",
    Liechtenstein: "LI",
    Lithuania: "LT",
    Luxembourg: "LU",
    Madagascar: "MG",
    Malawi: "MW",
    Malaysia: "MY",
    Maldives: "MV",
    Mali: "ML",
    Malta: "MT",
    "Marshall Islands": "MH",
    Mauritania: "MR",
    Mauritius: "MU",
    Mexico: "MX",
    Micronesia: "FM",
    Moldova: "MD",
    Monaco: "MC",
    Mongolia: "MN",
    Montenegro: "ME",
    Morocco: "MA",
    Mozambique: "MZ",
    Myanmar: "MM",
    Namibia: "NA",
    Nauru: "NR",
    Nepal: "NP",
    Netherlands: "NL",
    "New Zealand": "NZ",
    Nicaragua: "NI",
    Niger: "NE",
    Nigeria: "NG",
    "North Macedonia": "MK",
    Norway: "NO",
    Oman: "OM",
    Pakistan: "PK",
    Palau: "PW",
    Panama: "PA",
    "Papua New Guinea": "PG",
    Paraguay: "PY",
    Peru: "PE",
    Philippines: "PH",
    Poland: "PL",
    Portugal: "PT",
    Qatar: "QA",
    Romania: "RO",
    Russia: "RU",
    Rwanda: "RW",
    "Saint Kitts and Nevis": "KN",
    "Saint Lucia": "LC",
    "Saint Vincent and the Grenadines": "VC",
    Samoa: "WS",
    "San Marino": "SM",
    "Sao Tome and Principe": "ST",
    "Saudi Arabia": "SA",
    Senegal: "SN",
    Serbia: "RS",
    Seychelles: "SC",
    "Sierra Leone": "SL",
    Singapore: "SG",
    Slovakia: "SK",
    Slovenia: "SI",
    "Solomon Islands": "SB",
    Somalia: "SO",
  };
  const [bookss, setBookss] = useState([]);
  const [bookssRead, setBookssRead] = useState([]);
  useEffect(() => {
    const fetchWantToReadBooks = async () => {
      try {
        const res = await axios.get(`api/v1/review/book-statuswent/${id}`);
        console.log("Fetched books:", res.data); // 👈 Check what's actually returned
        setBookss(res.data);
      } catch (error) {
        console.error("Failed to fetch", error);
      }
    };

    fetchWantToReadBooks();
  }, [id]);

  useEffect(() => {
    const fetchReadBooks = async () => {
      try {
        const res = await axios.get(`api/v1/review/book-statusread/${id}`);
        console.log("Fetched books:", res.data); // 👈 Check what's actually returned
        setBookssRead(res.data);
      } catch (error) {
        console.error("Failed to fetch", error);
      }
    };

    fetchReadBooks();
  }, [id]);
  const [ratedBooks, setRatedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBook, setSelectedBook] = useState(null);

  useEffect(() => {
    const fetchRatedBooks = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `api/v1/review/recently-rated/${id}`
        );
        setRatedBooks(response.data.books);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching rated books:", error);
        setLoading(false);
      }
    };

    fetchRatedBooks();
  }, [id]);
  const handleAmbassador = () => {
    if (!user?._id) {
      toast.error("You must be logged in");
      return;
    }

    if (userId === id) {
      toast.error("You cannot request a chat with yourself");
      return;
    }
    if (socket) {
      console.log("Socket is connected:", socket.connected);
      socket.emit(
        "request_chat_m",
        {
          userId: userId,
          ambassadorId: id,
        },
        (response) => {
          console.log("Chat ID:", response.chatId);
          if (response.success) {
            navigate(
              `/chatChak/${response.chatId}?source=external`
            );
            console.log("Chat ID:", response.chatId);
            // store in state, navigate, etc.
          } else {
            console.error(
              "Failed to create chat:",
              response.message
            );
          }
        }
      );
    } else {
      toast.error("You must be logged in to request a chat.");
    }
  }
  return (
    < div className="bg-gradient-to-b from-white to-[#f7f7f7]">
      <div className="book2heder">
        <Header3 />
      </div>
      <div className="alincenterawidth scalmin1 d-none">
        <div className="d-lg-flex justzomag11  mlmrleading mlamruprof  gap-xl-5 gap-4 mt-5">
          <div className="textsmctrlead   ">
            {/* Header */}
            <div className="d-sm-flex  gap-2 gap-md-3 text-center text-sm-start ">
              <input
                type="file"
                accept="image/*"
                ref={fileInputRefLaed}
                style={{ display: "none" }} // Hide the input
                onChange={handleFileChangeLaed} // Handle file change
              />
              <img
                src={
                  user?.profileImage ? user?.profileImage?.startsWith("http") ? user?.profileImage :
                    BASE_URL + "/uploads/" + user.profileImage
                    : require("../pages/image/addphotoicon.png")
                } // Show user-selected image or default image
                alt="Profile"
                className="rounded-circle object-contain mx-md-3 widimg mlplux "
                width="150"
                height="150"
                style={{ cursor: "pointer", objectFit: "contain" }}
              //   style={{ width: "118px", height: "118px" }} // Set dimensions as needed
              // onClick={handleButtonClickLaed} // Allow clicking on the image to upload a new one
              />
              <div>
                <div
                  className=" mt-4 fw-bold fs-22 ftzpual text-dark "
                  style={{ lineHeight: "33.6px" }}
                >
                  {/* Sally Rooney */}
                  {user?.name}{" "}
                </div>

                <div className="  mt-3 d-flex gap-1 justify-content-center justify-content-sm-start ">
                  {/* <img
                  src={require("./image/femalevect.png")}
                  width="18"
                  height="22"
                /> */}
                  <img
                    src={require("./image/genderfemalehd.png")}
                    width="20"
                    height="24"
                  />
                  <div
                    className="fs-6   fw-normal"
                    style={{ color: "#696969" }}
                  >
                    {/* Female */}
                    {user?.gender}
                  </div>
                  <div className="mx-3 gap-1 d-flex">
                    <img
                      src={require("./image/gendermalehd.png")}
                      width="22"
                      height="24"
                    />

                    <div
                      className="fs-6 fw-normal"
                      style={{ color: "#696969" }}
                    >
                      {user?.dateOfBirth
                        ? `${calculateAge(user?.dateOfBirth)} Years`
                        : ""}
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-sm-start justify-content-center gap-2 mt-2 pt-1">
                  <img
                    src={require("./image/ambloct.png")}
                    width="18"
                    height="22"
                    style={{ width: "18px", height: "22px" }}
                  />
                  <div
                    className="fw-normal"
                    style={{ fontSize: "17px", color: "#696969" }}
                  >
                    {/* Amsterdam, NL */}
                    {capitalizeWords(user?.city)},{" "}
                    {countryNameToCode[user?.country]}
                  </div>
                </div>

                <div className="d-flex mt-2 pt-1 gap-2 justify-content-center justify-content-sm-start">
                  {user?.fbLinks?.length > 0 &&
                    user.fbLinks.map((link, idx) => (
                      <a
                        key={`fb-${idx}`}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("./image/facebooks.png")}
                          alt="Facebook"
                        />
                      </a>
                    ))}

                  {user?.instaLinks?.length > 0 &&
                    user.instaLinks.map((link, idx) => (
                      <a
                        key={`insta-${idx}`}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("./image/instagrams.png")}
                          alt="Instagram"
                        />
                      </a>
                    ))}

                  {user?.tiktokLinks?.length > 0 &&
                    user.tiktokLinks.map((link, idx) => (
                      <a
                        key={`tiktok-${idx}`}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("./image/tiktoks.png")}
                          alt="TikTok"
                        />
                      </a>
                    ))}

                  {user?.xLinks?.length > 0 &&
                    user.xLinks.map((link, idx) => (
                      <a
                        key={`x-${idx}`}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("./image/tweeters.png")}
                          alt="X (Twitter)"
                        />
                      </a>
                    ))}

                  {user?.linkdlnLinks?.length > 0 &&
                    user.linkdlnLinks.map((link, idx) => (
                      <a
                        key={`linkedin-${idx}`}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={require("./image/linkedin.png")}
                          style={{ width: "20px" }}
                          alt="LinkedIn"
                        />
                      </a>
                    ))}
                </div>
                {/* <div>
                <button
                  className="text-white mt-4 chatrebw rounded-1 fw-bold fs-5  ftzgern border-0 text-center"
                  style={{
                    width: "247px",
                    height: "39px",
                    backgroundColor: "#34C3C9",
                  }}
                >
                  Chat with Rebecca
                </button>
              </div> */}
              </div>
            </div>
          </div>

          <div className="mt-4 mx-3">
            <div className="fs-22 fw-bold ftzpual ">About me</div>
            <div
              className="fw-normal fs-18 w-100  ftzgern"
              style={{ maxWidth: "700px", textAlign: "justify" }}
            >
              {user?.aboutMe}
              {/* Sally Rooney was born in 1991 and lives in Dublin, where she
              graduated from Trinity College. Her work has appeared in Granta,
              The Dublin Review, The White Review, The Stinging Fly, and the
              Winter Pages anthology. */}
            </div>
          </div>
        </div>
        <div className="mx-md-5 mt-sm-5 mt-4 mb-4">
          <div
            className="mx-5 mt-5 textczoom11 fw-bold aboutauther text-center text-md-start"
            style={{ fontSize: "26px" }}
          >
            {/* Sally’s BookShelves */}
            {lg?.bookshelv}
          </div>
          <div>
            <div className=" mx-sm-5 textczoom11  fontupcon mlmrleading fw-bold mt-5 fs-22">
              {/* Want to Read */}
              {lg?.rewbtn1}
            </div>
            <div className="d-sm-block d-none mlmrbookuser my-5  grrapbooks mt-3  justify-content-center  gap-xl-2 gap-1 align-items-center">
              <Slider {...settingsd}>
                {/* <img
              style={{ rotate: "180deg" }}
              src={require("./image/moveimgarrow.png")}
              width="8"
              height="18"
            /> */}
                {/* <div className="d-sm-block scalmin d-none  gap-2 my-5 "> */}
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "", border: "white" }}
                  >
                    <Card.Img
                      className="imgsizesssaaa"
                      variant="top"
                      src={book.image}
                      style={{
                        width: "119px",
                        height: "170px",
                        cursor: "pointer",
                      }}
                    // onClick={() => navigate("/reviews")}
                    />
                    <Card.Body className=" p-0 mt-1 ">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <button
                          className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                          style={{
                            width: "122px",
                            height: "42px",
                          }}
                        ></button>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
                {/* </div> */}
                {/* <img
            src={require("./image/moveimgarrow.png")}
            width="8"
            height="18"
          /> */}
              </Slider>
            </div>

            <div className="d-sm-frrrlex d-none justzomag11 mx-5  align-items-center">
              <img
                style={{ rotate: "180deg" }}
                src={require("./image/moveimgarrow.png")}
                width="10"
                height="21"
              />

              <div className="d-flex flex-wrap jucfyy mx-3 gapambsread mt-3">
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsizesssaaa"
                      variant="top"
                      src={book.image}
                      style={{ width: "119px", height: "170px" }}
                    />
                    <Card.Body className=" p-0 mt-1 ">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <button
                          className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                          style={{
                            width: "122px",
                            height: "42px",
                          }}
                        ></button>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>

              <img
                src={require("./image/moveimgarrow.png")}
                width="10"
                height="21"
              />
            </div>

            {/* coursol */}
            <div className=" my-3 jucfyy mx-3 d-sm-none d-block ">
              <Slider {...settings}>
                {books.map((book, index) => (
                  <div key={index} className="d-flex justify-content-center">
                    <Card
                      key={index}
                      className="border-0 align-items-center"
                      style={{ width: "" }}
                    >
                      <Card.Img
                        className="imgsizesssaaaaaa"
                        variant="top"
                        src={book.image}
                        style={{ width: "130px", height: "170px" }}
                      />
                      <Card.Body className=" p-0 mt-1 ">
                        {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                        <div>
                          <button
                            className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                            style={{
                              width: "122px",
                              height: "42px",
                            }}
                          ></button>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div>
            <div className=" mx-sm-5 textczoom11 fontupcon mlmrleading fw-bold mt-4 fs-22">
              {/* Read */}
              {lg?.Read}
            </div>

            <div className="d-sm-block d-none mlmrbookuser my-5  grrapbooks mt-3  justify-content-center  gap-xl-2 gap-1 align-items-center">
              <Slider {...settingsd}>
                {/* <img
              style={{ rotate: "180deg" }}
              src={require("./image/moveimgarrow.png")}
              width="8"
              height="18"
            /> */}
                {/* <div className="d-sm-block scalmin d-none  gap-2 my-5 "> */}
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsizesssaaa"
                      variant="top"
                      src={book.image}
                      style={{
                        width: "119px",
                        height: "170px",
                        cursor: "pointer",
                      }}
                    // onClick={() => navigate("/reviews")}
                    />
                    <Card.Body className=" p-0 mt-1 ">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <button
                          className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                          style={{
                            width: "122px",
                            height: "42px",
                          }}
                        ></button>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
                {/* </div> */}
                {/* <img
            src={require("./image/moveimgarrow.png")}
            width="8"
            height="18"
          /> */}
              </Slider>
            </div>
            <div className="d-sm-ffffflex d-none  justzomag11 mx-5  align-items-center">
              <img
                style={{ rotate: "180deg" }}
                src={require("./image/moveimgarrow.png")}
                width="10"
                height="21"
              />

              <div className="d-flex flex-wrap jucfyy mx-3 gapambsread mt-3">
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsizesssaaa"
                      variant="top"
                      src={book.image}
                      style={{ width: "119px", height: "170px" }}
                    />
                    <Card.Body className=" p-0 mt-1 ">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <button
                          className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                          style={{
                            width: "122px",
                            height: "42px",
                          }}
                        ></button>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>

              <img
                src={require("./image/moveimgarrow.png")}
                width="10"
                height="21"
              />
            </div>

            {/* coursol */}
            {/* coursol */}
            <div className=" my-3 jucfyy mx-3 d-sm-none d-block ">
              <Slider {...settings}>
                {books.map((book, index) => (
                  <div key={index} className="d-flex justify-content-center">
                    <Card
                      key={index}
                      className="border-0 align-items-center"
                      style={{ width: "" }}
                    >
                      <Card.Img
                        className="imgsizesssaaaaaa"
                        variant="top"
                        src={book.image}
                        style={{ width: "130px", height: "170px" }}
                      />
                      <Card.Body className=" p-0 mt-1 ">
                        {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                        <div>
                          <button
                            className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                            style={{
                              width: "122px",
                              height: "42px",
                            }}
                          ></button>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div>
            <div className=" mx-sm-5 textczoom11 mlmrleading fontupcon fw-bold mt-4 fs-22">
              {/* Reviews */}
              {lg?.reviews}
            </div>

            <div className="d-sm-block d-none mlmrbookuser my-5  grrapbooks mt-3  justify-content-center  gap-xl-2 gap-1 align-items-center">
              <Slider {...settingsd}>
                {/* <img
              style={{ rotate: "180deg" }}
              src={require("./image/moveimgarrow.png")}
              width="8"
              height="18"
            /> */}
                {/* <div className="d-sm-block scalmin d-none  gap-2 my-5 "> */}
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsizesssaaa"
                      variant="top"
                      src={book.image}
                      style={{
                        width: "119px",
                        height: "170px",
                        cursor: "pointer",
                      }}
                    // onClick={() => navigate("/reviews")}
                    />
                    <Card.Body className=" p-0 mt-1">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <span
                          className="mx-2 text-warning"
                          style={{ fontSize: "21px" }}
                        >
                          ★★★★☆
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
                {/* </div> */}
                {/* <img
            src={require("./image/moveimgarrow.png")}
            width="8"
            height="18"
          /> */}
              </Slider>
            </div>
            <div className="d-sm-fggglex d-none justzomag11 mx-5  align-items-center">
              <img
                style={{ rotate: "180deg" }}
                src={require("./image/moveimgarrow.png")}
                width="10"
                height="21"
              />

              <div className="d-flex flex-wrap jucfyy mx-3 gapambs mt-3">
                {books.map((book, index) => (
                  <Card
                    key={index}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <Card.Img
                      className="imgsizesssaaa"
                      variant="top"
                      src={book.image}
                      style={{ width: "119px", height: "170px" }}
                    />
                    <Card.Body className=" p-0 mt-1">
                      {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div>
                        <span
                          className="mx-2 text-warning"
                          style={{ fontSize: "21px" }}
                        >
                          ★★★★☆
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>

              <img
                src={require("./image/moveimgarrow.png")}
                width="10"
                height="21"
              />
            </div>

            {/* coursol */}
            <div className=" my-3 jucfyy mx-3 d-sm-none d-block ">
              <Slider {...settings}>
                {books.map((book, index) => (
                  <div key={index} className="d-flex justify-content-center">
                    <Card
                      key={index}
                      className="border-0 align-items-center"
                      style={{ width: "" }}
                    >
                      <Card.Img
                        className="imgsizesssaaaaaa"
                        variant="top"
                        src={book.image}
                        style={{ width: "130px", height: "170px" }}
                      />
                      <Card.Body className=" p-0 mt-1">
                        {/* <Card.Text
                  className=" w-100 fw-bold ftzgern fs-6 mt-1"
                  style={{
                    color: "#383838",
                  }}
                >
                  {book.eventDate}
                </Card.Text>
                <Card.Title
                  className=" w-100 fs-5 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Title
                  className=" ftzgern fs-6 fw-bold m-0 "
                  style={{
                    color: "#C9321F",
                  }}
                >
                  {book.eventType}
                </Card.Title>

                <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-5">
                  {book.ageGroup}
                </Card.Title>
                <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                        <div>
                          <span
                            className="mx-2 text-warning"
                            style={{ fontSize: "21px" }}
                          >
                            ★★★★☆
                          </span>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-[1300px] mx-auto min-h-screen  p-6">
        <ProfileHeader
          image={

            user?.profileImage ? user?.profileImage?.startsWith("http") ? user?.profileImage :
              BASE_URL + "/uploads/" + user.profileImage
              : require("../pages/image/addphotoicon.png")
          }
          name={user?.name}
          gender={user?.gender}
          age={
            user?.dateOfBirth ? `${calculateAge(user?.dateOfBirth)}` : ""
          }
          city={
            user?.city || user?.country
              ? user?.city
                ? `${capitalizeWords(user.city)}${countryNameToCode[user?.country]
                  ? ", " + countryNameToCode[user.country]
                  : ""
                }`
                : countryNameToCode[user?.country] || ""
              : ""
          }
          user={user}
          handleAmbassador={handleAmbassador}
        />

        {/* About me */}
        <div className="mt-6 rounded-2xl bg-white p-5 ring-1 ring-slate-200 shadow-sm">
          <h2 className="mb-2 text-lg font-semibold">About me</h2>
          <p className="text-sm leading-6 text-slate-700">{user?.aboutMe}</p>
        </div>

        {/* Shelves */}
        <Shelf title="Want to read" data={bookss} read={true} />
        <Shelf title="Read" data={bookssRead} read={true} />
        <Shelf title="Reviews" data={ratedBooks} withRatings />
      </div>
      <div className="mt-5">
        <Footer2 />
      </div>
    </div>
  );
};

export default AmbassUserProfile;
